/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetMetricsQueryResponse, FilesControllerGetMetricsPathParams, FilesControllerGetMetrics400, FilesControllerGetMetrics401, FilesControllerGetMetrics403, FilesControllerGetMetrics404 } from "../../models/filesController/FilesControllerGetMetrics";

function getFilesControllerGetMetricsUrl(id: FilesControllerGetMetricsPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/files/${id}/metrics` as const }  
  return res
}

/**
 * @description Returns counts of reviews and playbooks applied to a file.
 * @summary Get metrics for a file
 * {@link /api/v1/files/:id/metrics}
 */
export async function filesControllerGetMetrics(id: FilesControllerGetMetricsPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerGetMetricsQueryResponse, ResponseErrorConfig<FilesControllerGetMetrics400 | FilesControllerGetMetrics401 | FilesControllerGetMetrics403 | FilesControllerGetMetrics404>, unknown>({ method : "GET", url : getFilesControllerGetMetricsUrl(id).url.toString(), ... requestConfig })  
  return res.data
}